import { LoadingSpinner } from '../components';
import { useEffect } from 'react';

export default function AuthRedirect() {
  useEffect(() => {
    const qs = window.location.href.split('#')[1];
    const parts = qs.split('&');
    const token_part = parts.find((p) => p.startsWith('access_token='));
    if (token_part) {
      const token = token_part.split('=')[1];
      window.opener.postMessage({ token });
    }
    setTimeout(() => {
      window.close();
    }, 300);
  }, []);

  return (
    <div className='page'>
      <LoadingSpinner />
    </div>
  );
}
